// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"313":"vendors_new-d14e76a1","4099":"vendors_new-59aa568f","6203":"vendors_new-78ed49d4","9874":"main-0a037d97"}[chunkId] + "." + {"313":"d1968fed22bb91ccc18e","4099":"3c596003a24a0ba794b0","6203":"a3f28bcea3725cf43664","9874":"9b64c17aaf004c4c276d"}[chunkId] + ".css";
};